import axios from 'axios';

// Some endpoints (e.g. CompanyInvitationController's @ExceptionHandler methods) return the
// error text as a plain string body instead of wrapping it in { message }, so check both shapes.
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (!axios.isAxiosError(err)) {
    return fallback;
  }

  const data: unknown = err.response?.data;
  if (typeof data === 'string' && data.trim()) {
    return data;
  }
  if (data && typeof data === 'object' && typeof (data as { message?: unknown }).message === 'string') {
    return (data as { message: string }).message;
  }

  return fallback;
}
